import { Stack, CircularProgress } from "@mui/material";

export default function Loader({size}){

    return <Stack direction='row' justifyContent='center' sx={{m: 2}}>
        <CircularProgress size={size || 40}/>
    </Stack>
}